import { jsPDF } from "jspdf";
import { services } from "@/data/siteData";

const NAVY = [26, 59, 122];
const CYAN = [41, 171, 226];

const safeText = (value, maxLength = 80) => String(value).replace(/[\r\n]+/g, " ").trim().slice(0, maxLength);

const addWrappedText = (doc, text, x, y, width, fontSize, lineHeight = 1.18) => {
  doc.setFontSize(fontSize);
  doc.text(doc.splitTextToSize(safeText(text), width), x, y, { lineHeightFactor: lineHeight });
};

export function buildCapabilityBrief() {
  if (services.length !== 7) throw new Error("The capability brief requires seven service families.");

  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4", putOnlyUsedFonts: true, compress: true });
  const pageWidth = 210;
  const pageHeight = 297;
  const margin = 15;
  const gap = 4;
  const cardWidth = (pageWidth - margin * 2 - gap * 2) / 3;
  const cardHeight = 51;

  doc.setFillColor(...NAVY);
  doc.rect(0, 0, pageWidth, 48, "F");
  doc.setFillColor(...CYAN);
  doc.rect(0, 45, pageWidth, 3, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(24);
  doc.text("VORTEX CORE", margin, 20);
  doc.setFontSize(11);
  doc.text("IT SERVICES LLC / PROCUREMENT BRIEF", margin, 29);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text("Seven practical technology families for businesses in Dubai and beyond.", margin, 39);

  const startY = 59;
  services.forEach((service, index) => {
    const row = Math.floor(index / 3);
    const column = index % 3;
    const x = margin + column * (cardWidth + gap);
    const y = startY + row * (cardHeight + gap);

    doc.setFillColor(247, 250, 253);
    doc.setDrawColor(215, 226, 238);
    doc.roundedRect(x, y, cardWidth, cardHeight, 2, 2, "DF");
    doc.setFillColor(...CYAN);
    doc.rect(x, y, 3.5, cardHeight, "F");

    doc.setTextColor(...NAVY);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8.3);
    addWrappedText(doc, `${service.number}  ${service.title}`, x + 8, y + 10, cardWidth - 13, 8.3, 1.05);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(71, 85, 105);
    addWrappedText(doc, service.short, x + 8, y + 22, cardWidth - 13, 6.8, 1.08);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...NAVY);
    doc.setFontSize(6.1);
    doc.text("SCOPE", x + 8, y + 33);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(71, 85, 105);
    doc.setFontSize(6.1);
    service.items.slice(0, 3).forEach((item, itemIndex) => doc.text(`• ${safeText(item, 30)}`, x + 8, y + 40 + itemIndex * 4));
  });

  doc.setDrawColor(...CYAN);
  doc.line(margin, 235, pageWidth - margin, 235);
  doc.setTextColor(...NAVY);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("A clear starting point for your next technology brief.", margin, 247);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(71, 85, 105);
  doc.setFontSize(7.5);
  doc.text("info@vortexcoreit.com", margin, 258);
  doc.text("Al Zahraa Techno Center, Office No. 101, Bur Dubai, Dubai, UAE", margin, 267);
  doc.setFontSize(6.7);
  doc.text("VORTEX CORE IT SERVICES LLC / DUBAI / 2026", pageWidth - margin, 280, { align: "right" });

  if (doc.getNumberOfPages() !== 1) throw new Error("The capability brief exceeded one page.");
  return doc;
}

export function generateCapabilityBrief() {
  buildCapabilityBrief().save("vortex-core-procurement-capability-brief.pdf");
}
